module.exports = __webpack_public_path__ + "Images/GraphHistoricSelected.png";


//////////////////
// WEBPACK FOOTER
// ./Images/GraphHistoricSelected.png
// module id = 1841
// module chunks = 2